import {StatusTaskSingleVoyage} from "@containers/singleVoyage/tasks/types";

/**
 * Label for a task status.
 *
 * The status is a roll-up over executions, so all six values reach this function,
 * IN_PROGRESS, CANCELLED and PARTIAL_COMPLETE included. Three of them used to fall
 * through to default and were rendered as the raw database name, while the keys
 * pointed at singleVoyage.tasksStatuses - a duplicate block that had drifted apart
 * from singleVoyage.taskStatuses.
 */
export const getLabelStatusTaskSingleVoyage = (status: StatusTaskSingleVoyage): string => {
    switch (status) {
        case "PLANNED":
            return 'singleVoyage.taskStatuses.planned'
        case "IN_PROGRESS":
            return 'singleVoyage.taskStatuses.inProgress'
        case "COMPLETED":
            return 'singleVoyage.taskStatuses.completed'
        case "PARTIAL_COMPLETE":
            return 'singleVoyage.taskStatuses.partialCompleted'
        case "CANCELLED":
            return 'singleVoyage.taskStatuses.cancelled'
        case "DELETED":
            return 'singleVoyage.taskStatuses.deleted'
        default :
            return status
    }
}
